// usePaymentProcessRecharge.js
import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import AtomAESWebCrypto from "../utils/AtomAES";
import { getapiKey } from "../api/axios";
import {
    initiateEasebuzzPaymentThunkRecharge,
    handleEasebuzzResponse,
    clearError,
} from "../features/payment/paymentSlice";
import { openEasebuzzPaymentModal, openCashfreePaymentModal, openAtomPaymentModal } from "./easebuzzServiceNew";

// import {
//     DoWalletTopUp,
//     clearWalletError,
// } from '../features/wallet/walletSlice';

export const usePaymentProcessRecharge = ({ SetErrorMessageRecharge, setpaymentHookStatusRecharge, SetResponseData }) => {
    const dispatch = useDispatch();
    const { walletpaymentStatus, walletpaymentData } = useSelector((state) => state.wallet);
    const { paymentInitiatedrecharge, paymentDatarecharge } = useSelector((state) => state.payment);
    // open Easebuzz modal when payment initiated
    useEffect(() => {
        if (paymentInitiatedrecharge && paymentDatarecharge?.accessKey) {
            try {
                if (paymentDatarecharge?.ActivePG === 2) {
                    openCashfreePaymentModal(paymentDatarecharge.enviroment, paymentDatarecharge.accessKey, paymentDatarecharge.paymentDetails, (response) => {
                        dispatch(handleEasebuzzResponse(response));
                        if (response.status === 'success') {
                            SetErrorMessageRecharge('success')
                            setpaymentHookStatusRecharge('success')
                            SetResponseData(response)

                        } else {
                            SetResponseData(response)
                            SetErrorMessageRecharge(response.status)
                            setpaymentHookStatusRecharge('paymentfailed')
                        }
                    });
                } else if (paymentDatarecharge?.ActivePG === 5) {

                    AtomAESWebCrypto.decrypt(
                        paymentDatarecharge.key,
                        getapiKey(),
                        getapiKey()
                    ).then((marchandID) => {
                        console.log("Merchant ID:", marchandID); // 445842
                        console.log(marchandID);
                        console.log(paymentDatarecharge);
                        openAtomPaymentModal(paymentDatarecharge.accessKey, marchandID, paymentDatarecharge.enviroment, paymentDatarecharge.paymentDetails, (response) => {
                            console.log(response);

                            // dispatch(handleEasebuzzResponse(response));
                            // if (response.status === 'success') {
                            //     SetErrorMessageRecharge('success')
                            //     setpaymentHookStatusRecharge('success')
                            //     SetResponseData(response)

                            // } else {
                            //     SetResponseData(response)
                            //     SetErrorMessageRecharge(response.status)
                            //     setpaymentHookStatusRecharge('paymentfailed')
                            // }
                        });
                    });

                } else {
                    openEasebuzzPaymentModal(paymentDatarecharge.enviroment, paymentDatarecharge.accessKey, paymentDatarecharge.paymentDetails, (response) => {

                        dispatch(handleEasebuzzResponse(response));
                        if (response.status === 'success') {
                            //if (paymentData.paymentDetails?.udf5 === 42) {
                            SetErrorMessageRecharge('success')
                            setpaymentHookStatusRecharge('success')
                            SetResponseData(response)
                            //} 
                            // else {
                            //     const WalletopUp = {
                            //         "customer_id": paymentData.paymentDetails?.udf4,
                            //         "currency": paymentData.paymentDetails?.udf6,
                            //         "amount": paymentData.paymentDetails?.amount,
                            //         "PaymentMode": response.card_type + '-Web-B2B',
                            //         "ReferenceNo": response.easepayid,
                            //         "Notes": 'Wallet Recharge - ' + response.easepayid
                            //     }

                            //     SetErrorMessageRecharge(response.status)
                            //     setpaymentHookStatusRecharge(response.status)
                            //     dispatch(clearWalletError());
                            //     dispatch(DoWalletTopUp({ WalletopUp })).unwrap();
                            // }


                            // dispatch(verifyEasebuzzPayment({
                            //   txn_id: response.txnid,
                            //   amount: formData.amount,
                            //   email: formData.email
                            // }));
                        } else {
                            SetResponseData(response)
                            SetErrorMessageRecharge(response.status)
                            setpaymentHookStatusRecharge('paymentfailed')
                        }
                    });
                }

            } catch (error) {
                SetErrorMessageRecharge("Failed to proceed payment");
                setpaymentHookStatusRecharge("paymentfailed");
                console.error("Failed to open payment modal:", error);
            }
        }
    }, [paymentInitiatedrecharge, paymentDatarecharge, dispatch, SetErrorMessageRecharge, setpaymentHookStatusRecharge, SetResponseData]);

    // useEffect(() => {
    //     if (walletpaymentStatus === true && walletpaymentData?.status?.success === true) {
    //         SetResponseData(walletpaymentData?.status?.success)
    //     }
    // }, [walletpaymentStatus, walletpaymentData]);
    // 🔑 handleProceed now accepts dynamic paymentDetails
    const handleProceedRecharge = useCallback(
        (paymentDetails, e) => {
            if (e) e.preventDefault();
            if (!paymentDetails) {
                SetErrorMessageRecharge("Missing payment details");
                return;
            }

            dispatch(clearError());
            dispatch(initiateEasebuzzPaymentThunkRecharge(paymentDetails));
        },
        [dispatch, SetErrorMessageRecharge]
    );

    return { handleProceedRecharge };
};


// import { useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//     initiateEasebuzzPaymentThunkRecharge,
//     handleEasebuzzResponse,
//     clearError,
// } from "../features/payment/paymentSlice";
// import { openEasebuzzPaymentModal } from "./easebuzzServiceNew";

// export const usePaymentProcess = ({ paymentDetails, SetErrorMessageRecharge, setpaymentHookStatusRecharge }) => {
//     const dispatch = useDispatch();
//     const { paymentInitiated, paymentData } = useSelector((state) => state.payment);

//     // open Easebuzz modal when payment initiated
//     useEffect(() => {
//         if (paymentInitiated && paymentData?.accessKey) {
//             try {
//                 openEasebuzzPaymentModal(paymentData.accessKey, paymentDetails, (response) => {
//                     console.log(response);

//                     dispatch(handleEasebuzzResponse(response));

//                     if (response.status !== "success") {
//                         SetErrorMessageRecharge(response.status);
//                         setpaymentHookStatusRecharge("paymentfailed");
//                     }
//                 });
//             } catch (error) {
//                 SetErrorMessageRecharge("Failed to proceed payment");
//                 setpaymentHookStatusRecharge("paymentfailed");
//                 console.error("Failed to open payment modal:", error);
//             }
//         }
//     }, [paymentInitiated, paymentData, dispatch, paymentDetails, SetErrorMessageRecharge, setpaymentHookStatusRecharge]);

//     // 🔑 Expose handleProceed function
//     const handleProceed = useCallback(
//         (e) => {
//             if (e) e.preventDefault();
//             dispatch(clearError());
//             dispatch(initiateEasebuzzPaymentThunkRecharge(paymentDetails));
//         },
//         [dispatch, paymentDetails]
//     );

//     return { handleProceed };
// };
